/* eslint-disable */
export default {
  audios: [],
  preload(sources) {
    if (!sources || !sources.length) return;

    this.clear();

    sources.forEach((source) => {
      this.addAudio(source);
    });
  },
  play(source, callback) {
    if (typeof source !== 'string') return;

    this.stop(source);

    const audio = this.getAudio(source);

    audio.play();

    if (typeof callback === 'function') {
      audio.addEventListener('ended', function handler(e) {
        audio.removeEventListener('ended', handler, false);
        callback(e);
      }, false);
    }
  },
  stop(source) {
    this.getAudio(source);

    this.audios.forEach((audio) => {
      if (!audio.paused) {
        audio.pause();
        if (!isNaN(audio.duration)) {
          audio.currentTime = 0;
        }
      }
    });
  },
  stopAll() {
    this.audios.forEach((audio) => {
      if (!audio.paused) {
        audio.pause();
        if (!isNaN(audio.duration)) {
          audio.currentTime = 0;
        }
      }
    });
  },
  pause(source) {
    const audio = this.getAudio(source);

    if (!audio.paused) {
      audio.pause();
    }
  },
  addAudio(source) {
    const audio = document.createElement('audio');
    audio.setAttribute('src', source);
    audio.setAttribute('preload', 'true');
    audio.setAttribute('style', 'display: none;');

    document.body.appendChild(audio);

    this.audios.push(audio);

    this.audios[source] = audio;

    return audio;
  },
  getAudio(source) {
    if (this.audios[source]) {
      return this.audios[source];
    }
    return this.addAudio(source);
  },
  removeAudio(audio) {
    this.pause(audio.src);

    document.body.removeChild(audio);

    delete this.audios[audio.src];
  },
  clear() {
    this.audios.forEach(audio => this.removeAudio(audio));

    this.audios = [];
  },
};
